/**
 * <ProtectedImg> — image protégée contre la copie/glisser-déposer.
 *
 * Empêche :
 *  - Le glisser-déposer (drag-and-drop)
 *  - Le menu contextuel (clic droit / long-press mobile) → bloque "Enregistrer sous…"
 *  - La sélection (highlight)
 *  - L'ouverture directe de l'URL (en partie — un utilisateur déterminé peut
 *    toujours accéder à l'URL via Inspecteur ou en cache). C'est une couche de
 *    DISSUASION suffisante pour le grand public, pas une protection cryptographique.
 *
 * Usage :
 *   <ProtectedImg src="/logo-maisonthai.png" alt="Maison Thaï" className="h-10" />
 *
 * Pour les photos produit du shop (Shop.jsx), même usage avec srcSet/sizes
 * supportés via passage transparent des props.
 */
import React from "react";

const ProtectedImg = React.forwardRef(function ProtectedImg(
  { className = "", style, onContextMenu, onDragStart, draggable, ...rest },
  ref,
) {
  const handleContextMenu = (e) => {
    e.preventDefault();
    if (onContextMenu) onContextMenu(e);
  };
  const handleDragStart = (e) => {
    e.preventDefault();
    if (onDragStart) onDragStart(e);
  };
  return (
    <img
      ref={ref}
      className={`protected-asset ${className}`.trim()}
      style={{
        WebkitUserDrag: "none",
        WebkitTouchCallout: "none",
        userSelect: "none",
        ...style,
      }}
      draggable={false}
      onContextMenu={handleContextMenu}
      onDragStart={handleDragStart}
      {...rest}
    />
  );
});

export default ProtectedImg;
